module.exports = __webpack_public_path__ + "img/car_00022.a5238404.jpg";